export const displayConstants = {
    SET_SIDEBAR: 'DISPLAY_SET_SIDEBAR',
    SET_CLIENT_CONTEXT_SUCCESS: 'SET_CLIENT_CONTEXT_SUCCESS',
    SET_CLIENT_CONTEXT_FAILURE: 'SET_CLIENT_CONTEXT_FAILURE',
    SET_STANDARD_REPORT_REQ_SUCCESS: 'SET_STANDARD_REPORT_REQ_SUCCESS',
    SET_STANDARD_REPORT_REQ_FALURE: 'SET_STANDARD_REPORT_REQ_FAILURE',
    SET_CALLINGLIST_REPORT_REQ_SUCCESS: 'SET_CALLINGLIST_REPORT_REQ_SUCCESS',
    SET_CALLINGLIST_REPORT_REQ_FALURE: 'SET_CALLINGLIST_REPORT_REQ_FAILURE'
};